import withErrorHandler from '../../../modules/error/ErrorHandlerWrapper';
import AddressModalBlock, { AddressModalBlockProps } from './AddressModalBlock';
import withInteractor from './AddressModalBlock.interactor';
import withPresenter from './AddressModalBlock.presenter';

export type { AddressModalBlockProps };
export default withInteractor(withPresenter(withErrorHandler(AddressModalBlock)))